import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigationContext } from '@contexts/navigation/navigation-context';

import { NavigationBackButtonProps } from './navigation-back-button.type';

export const NavigationBackButton = ({
  children,
  className = '',
  defaultRoute,
  forceDefaultRoute,
}: NavigationBackButtonProps) => {
  const navigate = useNavigate();

  const {
    preventRedirect,
    setIsItemClicked,
    setRedirectUrl,
    route: { from: fromRoute, to: toRoute },
  } = useContext(NavigationContext);

  const redirectUrl = forceDefaultRoute ? defaultRoute : fromRoute;

  const navigateToPrevious = () => {
    if (preventRedirect) {
      setIsItemClicked(true);
      setRedirectUrl(redirectUrl as string);
    } else if (fromRoute === toRoute) {
      navigate(defaultRoute);
    } else {
      navigate(redirectUrl);
    }
  };

  return (
    <button className={className} type='button' aria-label='Menu' onClick={navigateToPrevious}>
      {children}
    </button>
  );
};
